// load scss
import "./Main.scss";